import { VMessage } from "./VMessage";

export interface Chat {
  id?: string;
  userId?: string;
  storeId?: string;
  messages?: VMessage[];
  status?: ChatStatus;
  title?: string;
  createdAt?: Date;
  updatedAt?: Date;
}

export enum ChatStatus {
  OPEN = "open",
  CLOSED = "closed",
  PENDING = "pending",
}
